export const moduleName = 'tracking';

export const TRACK_LOGIN = `${moduleName}/TRACK_LOGIN`;
export const TRACK_REGISTER = `${moduleName}/TRACK_REGISTER`;
export const TRACK_CHECKOUT_STARTED = `${moduleName}/TRACK_CHECKOUT_STARTED`;
export const TRACK_SUBSCRIPTION_STEP_COMPLETED = `${moduleName}/TRACK_SUBSCRIPTION_STEP_COMPLETED`;
export const TRACK_PERSONAL_DETAILS_VIEWED = `${moduleName}/TRACK_PERSONAL_DETAILS_VIEWED`;
export const TRACK_PERSONAL_DETAILS_COMPLETED = `${moduleName}/TRACK_PERSONAL_DETAILS_COMPLETED`;
export const TRACK_ORDER_COMPLETED = `${moduleName}/TRACK_ORDER_COMPLETED`;
export const IDENTIFY_SIGNUP = `${moduleName}/IDENTIFY_SIGNUP`;

export const checkoutStarted = () => ({ type: TRACK_CHECKOUT_STARTED });
export const orderCompleted = confirmation => ({
  type: TRACK_ORDER_COMPLETED,
  payload: { confirmation },
});
export const subscriptionStepCompleted = checkoutId => ({
  type: TRACK_SUBSCRIPTION_STEP_COMPLETED,
  payload: { checkoutId },
});
export const detailsViewed = checkoutId => ({
  type: TRACK_PERSONAL_DETAILS_VIEWED,
  payload: { checkoutId },
});
export const detailsCompleted = checkoutId => ({
  type: TRACK_PERSONAL_DETAILS_COMPLETED,
  payload: { checkoutId },
});
export const identifySignUp = userInfo => ({
  type: IDENTIFY_SIGNUP,
  payload: userInfo,
});
export const trackLogin = userInfo => ({
  type: TRACK_LOGIN,
  payload: userInfo,
});
export const trackRegister = userInfo => ({
  type: TRACK_REGISTER,
  payload: userInfo,
});
